import type { BrandInsightsContext, BrandInsightsInstanceContext } from '@trinity/chat';
import { ChatContextType } from '@trinity/chat';
import type { ChatSessionState, ChatState } from './interfaces';

type State = ChatSessionState.State['chatInstance'];

export function chatInstanceReducer(state: State, action: ChatState.Action): State {
  switch (action.type) {
    case 'chat-instance-subject-updated': {
      if (state.context.type !== ChatContextType.Agent) {
        return state;
      }

      return {
        ...state,
        context: {
          ...state.context,
          data: {
            ...state.context.data,
            subject: action.payload.subject,
          },
        },
      };
    }

    case 'query-submitted': {
      return {
        ...state,
        currentQueryIdentifier: action.payload.identifier,
      };
    }

    case 'query-response-available': {
      return {
        ...state,
        context: action.payload.chatInstance.context,
        id: action.payload.chatInstance.id,
        currentQueryIdentifier: action.payload.query.identifier,
        name: action.payload.chatInstance.name,
        filterOverrides: action.payload.chatInstance.filterOverrides,
        filters: action.payload.chatInstance.filters,
      };
    }

    case 'folder-name-updated': {
      return {
        ...state,
        context: {
          ...state.context,
          type: ChatContextType.Folder,
          metadata: {
            ...state.context.metadata,
            name: action.payload.value,
          } as BrandInsightsContext.Folder.Metadata,
        } as BrandInsightsInstanceContext.FolderWithMetadata,
      };
    }

    default:
      return state;
  }
}
